import {
  AnnouncementTypesColors,
  AnnouncementTypesTitles,
} from '../../constants';
import { Announcement as TAnnouncement } from '../../types/announcements';
import getDateRangeString from '../functions/getDateRangeString/getDateRangeString';

type Props = {
  onViewMoreClick: (selectedAnnouncement: TAnnouncement) => void;
  announcement: TAnnouncement;
};

const Announcement = ({ announcement, onViewMoreClick }: Props) => {
  const dotColor = AnnouncementTypesColors[announcement.type];

  return (
    <>
      <div className='d-flex flex-column gap-1 py-2 px-2 ps-4 announcement'>
        <span className='announcement-date'>
          {getDateRangeString(announcement.publish_date, announcement.end_date)}
        </span>
        <span
          className='announcement-title'
          style={{ '--dot-color': dotColor } as React.CSSProperties}
        >
          {AnnouncementTypesTitles[announcement.type]} - {announcement.title}
        </span>
        <span className='announcement-content'>{announcement.snippet}</span>
        <span
          onClick={() => onViewMoreClick(announcement)}
          className='announcement-link btn-inline btn-link'
        >
          View More
        </span>
      </div>
    </>
  );
};
export default Announcement;
